import convertToCurrency from '@naturehouse/nh-essentials/lib/currency/currencyHelper';
import {
    FORMATS,
    intlDateFormat
} from '@naturehouse/nh-essentials/lib/dates/intlDateTimeFormatter';
import { TravelPartyDataParameters } from '../../listing/components/DetailForm';

export default class HouseSearchListItemsFactory {
    static fromResponseData(data: HouseSearchResponse): HouseSearchListItem[] {
        return HouseSearchListItemsFactory.fromArray(
            data.houses,
            data.calculateTouristTaxHouseIds ?? []
        );
    }

    static fromArray(
        houses: HouseSearchResponseItem[],
        calculateTouristTaxHouseIds: number[] = []
    ): HouseSearchListItem[] {
        return houses.map((house): HouseSearchListItem => {
            const houseUrl = new URL(window.location.origin + house.websiteUrl);
            const currentUrl = new URL(window.location.href);

            const adults = currentUrl.searchParams.get(TravelPartyDataParameters.ADULTS);
            const children = currentUrl.searchParams.get(TravelPartyDataParameters.CHILDREN);
            const babies = currentUrl.searchParams.get(TravelPartyDataParameters.BABIES);
            const pets = currentUrl.searchParams.get(TravelPartyDataParameters.PETS);

            if (adults) houseUrl.searchParams.set(TravelPartyDataParameters.ADULTS, adults);
            if (children) houseUrl.searchParams.set(TravelPartyDataParameters.CHILDREN, children);
            if (babies) houseUrl.searchParams.set(TravelPartyDataParameters.BABIES, babies);
            if (pets) houseUrl.searchParams.set(TravelPartyDataParameters.PETS, pets);

            const listItem: HouseSearchListItem = {
                id: house.id,
                isPriceExcludingTouristTax: calculateTouristTaxHouseIds.includes(house.id),
                websiteUrl: houseUrl.href,
                extraCostsUrl: house.extraCostsUrl,
                title: house.title,
                locationTitle: house.locationTitle,
                price: house.price,
                imageUrl: house.imageUrl || '/images/placeholder.jpg',
                features: house.features,
                persons: house.persons,
                bedrooms: house.bedrooms,
                natureRating: house.natureRating,
                houseRating: house.houseRating,
                latitude: house.geoPoint?.lat,
                longitude: house.geoPoint?.lon,
                distance: house.distance,
                images: house.images,
                sustainabilityScore: house.sustainabilityScore ?? null,
                externalId: house.externalId ?? undefined,
                country: house.location.country,
                region: house.location.region,
                department: house.location.department,
                naturalArea: house.location.naturalArea,
                place: house.location.place
            };

            if (house.externalId) {
                listItem.externalId = house.externalId;
            }

            if (house.price && Object.keys(house.price).length) {
                HouseSearchListItemsFactory.#setPricingInformation(listItem, house);
            }

            return listItem;
        });
    }

    static #setPricingInformation(
        listItem: HouseSearchListItem,
        house: HouseSearchResponseItem
    ): void {
        listItem.price.totalFormatted = convertToCurrency(Number(house.price.total));
        listItem.price.dayPriceFormatted = convertToCurrency(Number(house.price.dayPrice));
        listItem.price.startDateFormatted = intlDateFormat(house.price.startDate, FORMATS.LONG);

        if (house.price.dayPriceWithDiscount) {
            listItem.price.dayPriceWithDiscountFormatted = convertToCurrency(
                Number(house.price.dayPriceWithDiscount)
            );
        }

        if (listItem.price.totalWithDiscount) {
            listItem.price.totalWithDiscountFormatted = convertToCurrency(
                Number(listItem.price.totalWithDiscount)
            );
        }
    }
}
